import { fg } from '@atlassian/jira-feature-gating';
import type { RouteResource } from '@atlassian/react-resource-router';
import { uifBacklogResource } from '@jira/router-resources__classic-projects-uif-backlog/src/uifBacklogResource.tsx';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import { boardDataResource } from './boardDataResource.tsx';
import { rapidboardResource } from './rapidboardResource.tsx';
import { wrmBundleResource } from './wrmBundleResource.tsx';

export const shouldLoadUIFBoardResources = (): boolean => !__SERVER__;
export const shouldLoadLegacyBoardResources = (): boolean => !shouldLoadUIFBoardResources();

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const getRapidboardResources = (): RouteResource<any>[] => [
	wrmBundleResource,
	resourceWithCondition(shouldLoadLegacyBoardResources, rapidboardResource),
];

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const getRapidBoardDataResource = (): RouteResource<any> => boardDataResource;

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const getUIFBacklogDataResource = (): RouteResource<any>[] => [
	resourceWithCondition(
		() =>
			!fg('jira_backlog_cmp_relay') &&
			(shouldLoadUIFBoardResources() || fg('enable_ssr_for_cmp_backlog')),
		uifBacklogResource,
	),
];
